<template>
<div :class="tickMarkSize">
 <div class="circle">
  <div class="fill-skew-left"></div>
  <div class="fill-skew-right"></div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    tickMarkSize: {
      type: String,
      default: 'tick-mark-small'
    }
  }
}
</script>